<template>
	<div class="login-background">
		<div class="login-main">
			<div class="login-main-left">
				<div class="backImg">
					<img :src="logo" alt="">
				</div>
			</div>
			<div class="login-main-right">
				<div class="formBox">
					<div v-show="status == 'login'" class="login-main-right-form">
						<h4>登录</h4>
						<el-tabs ref="tabsRef" v-model="activeName" @tab-click="handleClick">
							<el-tab-pane label="密码登录" name="first">
								<LoginForm @switchStatus="switchStatus"></LoginForm>
							</el-tab-pane>
							<el-tab-pane label="验证码登录" name="second">
								<CodeForm @switchStatus="switchStatus"></CodeForm>
							</el-tab-pane>
							<el-tab-pane label="二维码登录" name="third">
								<QR ref="qrRef" />
							</el-tab-pane>
						</el-tabs>
					</div>
					<div v-show="status == 'register'" class="register-main-right">
						<h3>欢迎来到{{ APP_WINNY_NAME }}</h3>
						<div class="QR-register">
							<vue-qr id="picture" class="qrcode" :text="registerUrl" :margin="3" color-dark="#000" color-light="#fff"
								:dot-scale="1" :size="400"></vue-qr>
						</div>
						<h3>请使用微信扫码注册</h3>
						<div class="register-tip">
							<span>已有账号？</span>
							<a @click="switchStatus('login')" href="#">登录</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import vueQr from 'vue-qr'
import LoginForm from './components/LoginForm.vue'
import CodeForm from './components/CodeForm.vue'
import QR from './components/QR.vue'
export default {
	name: 'login',
	data() {
		return {
			qrRef: null,
			logo: null,
			registerUrl: window.g.REGISTER_URLS_CODE,
			APP_WINNY_NAME: window.g.APP_WINNY_NAME,
			tabsRef: null,
			activeName: 'first',
			status: 'login',
			qrNum: 0 // 是否打开二维码页面
		};
	},
	components: {
		LoginForm,
		CodeForm,
		QR,
		vueQr
	},
	mounted() {
		this.getLogo()
	},
	methods: {
		getLogo() {
			protocol.param_getContentDetails.param.id = 1
			http.getRes(protocol.param_getContentDetails).then(response => {
				const { code, message, value } = response.data
				if (code === 0 || code === '0') {
					this.logo = value.titleImg
				} else {
					this.$toast(message)
				}
			})
		},
		handleClick(tab) {
			this.$nextTick(() => {
				let ele = document.getElementsByClassName('el-tabs__active-bar')[0];
				if (tab.index == '1') {
					ele.style.left = 14 + 64 + 'px'
					if (this.qrNum === 1) {
						this.qrNum = 0
						this.$refs.qrRef.clearCode()
					}
				} else if (tab.index == '2') {
					ele.style.left = 144 + 'px'
					this.qrNum = 1
					this.$refs.qrRef.changLoginWay()
				} else {
					ele.style.left = 8 + 'px'
					if (this.qrNum === 1) {
						this.qrNum = 0
						this.$refs.qrRef.clearCode()
					}
				}
			})
		},
		switchStatus(status) {
			this.status = status
		}
	}
}
</script>

<style lang="scss">
.el-tabs__active-bar {
	transition: none;
}

.el-tabs__item {
	padding: 0;
}

// .el-form-item__error{
//     font-family: Source Han Sans SC;
//     font-weight: 400;
//     font-size: 16px;
//     color: #FF3A3A;
//     margin: 10px 0 13px 13px;
// }
#tab-second {
	margin: 0 63px;
}

.login {
	&-background {
		min-width: 1200px;
		height: 100vh;
		background-color: #fff;
	}

	&-main {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;

		&-left {
			position: relative;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			flex: 1;
			height: 100%;
			background: #121212;
			font-family: Source Han Sans SC;
			font-weight: bold;
			font-size: 46px;
			color: #FEFEFE;
			line-height: 39px;
			transition: all .4s ease-in;

			@media screen and (max-width:1450px) {
				flex: 0;
				width: 0;
			}

			.backImg {
				position: absolute;
				z-index: 1;
				width: 100%;
				height: 100%;

				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}

			.viewBox {

				position: relative;
				z-index: 2;
				padding-bottom: 180px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				height: 488px;
			}

			&-title {

				span:first-child {
					display: inline-block;
					margin-bottom: 15px;
				}
			}

			&-img {
				margin-top: 186px;
				width: 160px;
				height: 160px;

				box-sizing: border-box;

				img {
					width: 100%;
					height: 100%;
				}
			}
		}

		&-right {
			display: flex;
			// width: 1140px;
			flex: 1.7;
			justify-content: center;
			align-items: center;
			height: 100%;

			.formBox {
				height: 488px;

			}

			&-form {
				width: 571px;

				h4 {
					font-family: Source Han Sans SC;
					font-weight: bold;
					font-size: 20px;
					color: #333333;
					margin-bottom: 44px;
				}

				.RegisterTip {
					margin-top: 25px;
					display: flex;
					justify-content: center;
					color: #999999;
					font-size: 20px;

					a {
						color: #333333;
						border-bottom: 1px solid #333333;
					}
				}

				.el-tabs__header {
					margin-bottom: 28px;
				}

				.el-tabs__nav-wrap::after {
					background-color: transparent;
				}

				.el-tabs__active-bar {
					width: 40px !important;
					left: 8px;
					background-color: #000000;
				}

				.el-tabs__item {
					font-family: Source Han Sans SC;
					font-weight: 400;
					font-size: 16px;
					color: #333333;
				}

				.el-tabs__item.is-active {
					color: #333333;
				}

				.el-form-item {
					margin-top: 1px;

				}

				.el-input {
					border-radius: 6px;
					height: 43px;

					.el-input__inner {
						border-radius: 6px;
						height: 100%;
						border: 1px solid #999999;
					}

					.el-input__inner:focus {
						border-color: #333333;
					}
				}

				.el-checkbox__inner {
					border-color: #999999;
				}

				.el-checkbox__input.is-checked .el-checkbox__inner {
					background-color: #000000;
					border-color: #000000;
				}

				.el-checkbox__input.is-focus .el-checkbox__inner {

					border-color: #000000;
				}

				.el-radio__inner {
					border-radius: 20%;
					border-color: #999999;
				}

				.el-radio__label {
					font-family: Source Han Sans SC;
					font-weight: 200;
					font-size: 16px;
					color: #999999;
				}

				.el-button {
					color: #999999;
					width: 100%;
					height: 43px;
					border-radius: 34.5px;
					background-color: #F1F1F1;

					&.btn-active {
						background-color: #333333;
						color: #F1F1F1;
					}
				}
			}
		}
	}
}

.register-main-right {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	font-family: Source Han Sans SC;
	font-weight: bold;
	font-size: 20px;
	color: #333333;

	.QR-register {
		width: 130px;
		height: 130px;
		background-color: #333333;
		margin-bottom: 20px;

		img {
			width: 100%;
			height: 100%;
		}
	}

	h3:nth-of-type(1) {
		font-family: Source Han Sans SC;
		font-weight: bold;
		font-size: 20px;
		color: #333333;
		margin-bottom: 30px;
	}

	h3:nth-of-type(2) {
		font-family: Source Han Sans SC;
		font-weight: bold;
		font-size: 14px;
		color: #333333;
		margin-bottom: 7px;
	}

	.register-tip {
		span {
			font-family: Source Han Sans SC;
			font-weight: bold;
			font-size: 14px;
			color: #333333;
		}

		a {
			font-family: Source Han Sans SC;
			font-weight: bold;
			font-size: 14px;
			color: #0057C3;
		}
	}
}
</style>